import type { ReactNode } from "react";
import { hasPriceStrip, popupDomId, sanitizeColor, type PublicPopup } from "@/lib/popups";
import PopupCloseButton from "./PopupCloseButton";

/**
 * Üst şerit kabuğu (sunucu ve istemci ortak). Fiyat şeridi header gibi koyu adadır
 * (yüzey rengi; yükseliş/düşüş renkleri marka zemininde okunmuyor);
 * metin şeridi eskisi gibi marka renginde. Admin renk girdiyse o kazanır.
 */
export default function TopbarShell({ popup, children, script }: { popup: PublicPopup; children: ReactNode; script?: string }) {
  const strip = hasPriceStrip(popup);
  return (
    <>
      <div
        id={popupDomId(popup.id)}
        suppressHydrationWarning
        data-theme={strip ? "dark" : undefined}
        role="region"
        aria-label={popup.title || "Duyuru"}
        className={`relative z-40 border-b px-4 text-sm ${strip ? "border-(--color-border) bg-(--color-surface) text-(--color-foreground)" : "border-black/10 shadow-sm"}`}
        style={{
          backgroundColor: sanitizeColor(popup.background_color) ?? (strip ? undefined : "var(--brand)"),
          color: sanitizeColor(popup.text_color) ?? (strip ? undefined : "var(--brand-fg)"),
        }}
      >
        <div className="mx-auto flex h-9 max-w-7xl items-center gap-3 overflow-hidden">
          {children}
          <PopupCloseButton popup={popup} />
        </div>
      </div>
      {script ? <script dangerouslySetInnerHTML={{ __html: script }} /> : null}
    </>
  );
}
